<template>
  <v-chip class="service-chip" outlined>
    <div>
      <div class="service-chip__title">
        {{ name }}
      </div>
      <div v-if="price" class="service-chip__price">
        {{ $t("message.facilityDetails.services.price") }}: {{ price }}
      </div>
    </div>
    <v-menu
      v-if="canEditFacilityServices"
      offset-y
      content-class="services-menu__popup"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="service-chip__action" v-bind="attrs" v-on="on">
          <v-icon size="22px" class="ml-2">
            icon-more
          </v-icon>
        </div>
      </template>
      <v-list class="services-menu">
        <v-list-item class="services-menu__item" @click="$emit('edit')">
          <v-list-item-title
            >{{ $t("message.common.edit") }}
            <v-icon size="22px">icon-edit</v-icon></v-list-item-title
          >
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item class="services-menu__item" @click="$emit('delete')">
          <v-list-item-title
            >{{ $t("message.common.delete") }}
            <v-icon color="red" size="22px">icon-trash</v-icon>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-chip>
</template>

<script>
import { permissionsInfo } from "@/helpers/mixins/permissions-info";

export default {
  name: "GmbServicePreviewChip",
  mixins: [permissionsInfo],
  props: {
    name: {
      type: String,
      required: true
    },
    price: {
      type: String
    }
  }
};
</script>
<style lang="scss" scoped>
.services-menu {
  padding: 0;

  &__popup {
    border-radius: 18px !important;
  }

  .v-list-item {
    cursor: pointer;
    min-height: 40px;
    & + & {
      border-top: 1px solid $gray;
    }
    &:hover {
      background: $gray-200;
    }

    &__title {
      font-size: 14px;
      font-weight: 500;
      line-height: 17px;
      display: flex;
      align-items: center;
      gap: $spacing;
    }
  }
}

.service-chip {
  &::v-deep.v-chip {
    padding-left: $spacing * 2;
    padding-right: $spacing * 2;
  }
  &__price {
    color: $gray;
    font-size: 11px;
    font-weight: 500;
    line-height: 1em;
  }
}
</style>
